import React, { useState, useEffect } from 'react'
import { useDiasDaGrade, AvisoDiasDaGrade } from '../../components/GradeHoraria'
import { useNavigate, useLocation } from 'react-router-dom'
import {
    clssInfo,
    GetAttendanceFinalized,
    Attendance,
    updateAttendance,
    DestroyAttendance,
    getIstQuarter,
    getIIndQuarter,
    getIIIrdQuarter,
    getIVthQuarter,
    getSchoolYear,
    getSchoolDays
    //getVthQuarter,
    //getVIthQuarter,
} from '../../Api'

//import SelectorDate from '../../components/SelectorOnDate'

import {
    Container,
    List,
    ListChecked,
    Emp,
    //Matter,
    //DivInfo,
    Span,
    ContainerDivs,
    Btt02,
    DivInfoDate,
    ContainerStudent,
    DivButton,
    EditContainer,
    SpanChecked,
    DataSelected,
    BoxButton,
    BoxButtonEdit,
    //BoxButtonStatus,
    //EmpEdit,
    ToGoBack,
    SignMessageButtonText,
    SignMessageButtonTextBold,
    SkeletonItem
} from './style';

import {
} from '../../components/Inputs'
import LoadingSpinner from '../../components/LoadingFrequence'

import { SlActionUndo } from "react-icons/sl";

const IndexAttendance = () => {

    const navigate = useNavigate()
    //const [matter, setMatter] = useState([])
    //const [Namematter, setNameMatter] = useState([])
    const [open, setopen] = useState('aberto')
    //const [id_matter, setclickMatter] = useState([])
    const [id_class, setId_class] = useState([])
    const [id_teacher, setId_teacher] = useState('')
    const [stdt, setStdt] = useState([])
    const [checked, setChecked] = useState([])
    const [selectedDate, setSelectedDate] = useState('')
    const [day, setDay] = useState('')
    const [month, setMonth] = useState('')
    const [year, setYear] = useState('')
    const [namestudent, setNamestudent] = useState('')
    const [editingStudent, setEditingStudent] = useState(null); // Estado para aluno em edição
    const [editingStatus, setEditingStatus] = useState('');
    //const [Student, setStudent] = useState(null); // Estado para aluno em edição
    //const [Status, setStatus] = useState('');
    const [loading, setLoading] = useState(false);
    const [loadingList, setLoadingList] = useState(false);


    const [excludedStudents, setExcludedStudents] = useState([]);
    const [attendanceList, setAttendanceList] = useState([]);
    const [RemoveAttendanceList, setRemoveAttendanceList] = useState([]);

    const [RegentTeacher, setclassRegentTeacher] = useState([]);
    const [RegentTeacher02, setclassRegentTeacher02] = useState([]);
    const [physicalEducation, setphysicalEducationTeacher] = useState([]);

    const [schoolDays, setSchoolDays] = useState([]); // array de dias letivos
    const [isValidSchoolDay, setIsValidSchoolDay] = useState(true); // boolean

    const [tempDate, setTempDate] = useState("");
    // grade horária: só os dias em que o professor tem aula nesta turma (+ sábados letivos)
    const gradeDias = useDiasDaGrade(typeof id_class === 'string' ? id_class : '', (id_teacher && (id_teacher._id || id_teacher)) || '');
    const foraDaGradeTemp = tempDate && !gradeDias.permitido(tempDate) ? gradeDias.mensagem(tempDate) : '';

    const sameId = (a, b) => String(a) === String(b);

    // ─────────────────────────────────────────────────────────────────────────
    // Resolve corretamente o contexto do professor
    // ─────────────────────────────────────────────────────────────────────────
    const resolveTeacherContext = () => {

        if (!id_teacher) {
            console.warn(
                'resolveTeacherContext: id_teacher ainda não carregado.'
            );
            return null;
        }

        // REGENTE PRINCIPAL
        if (sameId(RegentTeacher, id_teacher)) {

            return {
                isPhysicalEducation: false,
                id_teacher: id_teacher,
                id_teacher02: RegentTeacher02 || null,
            };
        }

        // PROFESSOR 02
        if (sameId(RegentTeacher02, id_teacher)) {

            return {
                isPhysicalEducation: false,
                id_teacher: RegentTeacher,
                id_teacher02: RegentTeacher02,
            };
        }

        // EDUCAÇÃO FÍSICA
        if (sameId(physicalEducation, id_teacher)) {

            return {
                isPhysicalEducation: true,
                id_teacher: id_teacher,
                id_teacher02: null,
            };
        }

        console.error(
            'Professor não reconhecido',
            {
                id_teacher,
                RegentTeacher,
                RegentTeacher02,
                physicalEducation
            }
        );

        return null;
    };

    const location = useLocation();
    const { employee } = location.state || {};
    console.log("id employee", employee)

    useEffect(() => {
        (async () => {
            setLoading(true);
            const idTeacher = employee; // Remove aspas extras
            setId_teacher(idTeacher);
            const id_class = sessionStorage.getItem("class-info");
            setId_class(id_class);
            //const Matter = sessionStorage.getItem("attendance_ idmatter");
            const selectedDate = sessionStorage.getItem("selectedDate");

            const idSchool = sessionStorage.getItem("id-school");
            const yearRes = await getSchoolYear(JSON.parse(idSchool));
            const year = yearRes?.data?.data;

            const schoolDaysRes = await getSchoolDays(JSON.parse(idSchool), year);

            if (schoolDaysRes?.data) {
                setSchoolDays(schoolDaysRes.data.schoolDays);
            }

            if (selectedDate) {

                const Day = sessionStorage.getItem("day");
                const Month = sessionStorage.getItem("month");
                const Year = sessionStorage.getItem("year");

                setSelectedDate(selectedDate);
                setDay(JSON.parse(Day));
                setMonth(JSON.parse(Month));
                setYear(JSON.parse(Year));

                const classRegentTeacher = sessionStorage.getItem("classRegentTeacher");
                const classRegentTeacher02 = sessionStorage.getItem("classRegentTeacher02");
                const physicalEducationTeacher = sessionStorage.getItem("physicalEducationTeacher");

                setclassRegentTeacher(JSON.parse(classRegentTeacher))
                setclassRegentTeacher02(JSON.parse(classRegentTeacher02))
                setphysicalEducationTeacher(JSON.parse(physicalEducationTeacher))

            }

            setLoading(false);
        })();
    }, [employee]);

    useEffect(() => {
        if (!day || !month || !year || !id_class || !id_teacher) return;

        const fetchData = async () => {
            setLoadingList(true);

            try {
                const teacherToUse =
                sameId(RegentTeacher02, id_teacher) ? RegentTeacher : id_teacher;

                const resAtt = await GetAttendanceFinalized(
                    month,
                    year,
                    day,
                    id_class,
                    teacherToUse
                );

                const resClass = await clssInfo(id_class);

                const attData = resAtt?.data?.data || [];
                const classData = resClass?.data?.data?.[0];

                if (!classData) {
                    setStdt([]);
                    setChecked([]);
                    return;
                }
                const filteredByTeacherType = attData.filter(item => {
                    const isPE = item.isPhysicalEducation; // true/false ou undefined
                    if (sameId(physicalEducation, id_teacher)) {
                        // Se for professor de Ed. Física, pega só as chamadas com isPhysicalEducation: true
                        return isPE === true;
                    } else if (sameId(RegentTeacher, id_teacher)) {
                        // Se for professor regente, pega chamadas com isPhysicalEducation: false ou undefined
                        return isPE === false || isPE === undefined;
                    }
                    return true; // fallback, caso nenhum tipo definido
                });

                const attRealized = filteredByTeacherType.map(res => res.id_student._id);

                const students = classData.id_student
                    .filter(student => !attRealized.includes(student._id))
                    .sort((a, b) => a.name.localeCompare(b.name));

                setStdt(students);
                setChecked(
                    filteredByTeacherType.sort((a, b) =>
                        a.id_student.name.localeCompare(b.id_student.name)
                    )
                );

            } catch (err) {
                console.error("Erro ao carregar dados:", err);
                setStdt([]);
                setChecked([]);
            }

            setLoadingList(false);
        };

        fetchData();

    }, [day, month, year, id_class, id_teacher, RegentTeacher, RegentTeacher02, physicalEducation]);

    useEffect(() => {
        if (!day || !month || !year || !Array.isArray(schoolDays)) return;

        const selected = `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;

        const isValid = schoolDays.includes(selected);

        setIsValidSchoolDay(isValid);

    }, [day, month, year, schoolDays]);

    const markAllAsPresent = () => {

        const ctx = resolveTeacherContext();

        if (!ctx) {

            alert(
                'Aguarde o carregamento dos dados do professor.'
            );

            return;
        }

        const allPresent = stdt.map(student => ({

            id_student: student._id,

            status: "P",

            day,
            month,
            year,

            id_teacher: ctx.id_teacher,

            id_teacher02: ctx.id_teacher02,

            id_class,

            isPhysicalEducation: ctx.isPhysicalEducation
        }));

        setAttendanceList(allPresent);
    };

    useEffect(() => {
        if (!editingStudent) return;

        setEditingStatus(editingStudent.status);
    }, [editingStudent]);

    if (selectedDate) {
        sessionStorage.setItem("selectedDate", selectedDate)
        sessionStorage.setItem("day", day)
        sessionStorage.setItem("month", month)
        sessionStorage.setItem("year", year)

        const fetchQuarters = async () => {
            const idSchool = sessionStorage.getItem("id-school");

            const dateSelected = new Date(year, month - 1, day);

            const IstQuarter = await getIstQuarter(year, JSON.parse(idSchool))
            const IIndQuarter = await getIIndQuarter(year, JSON.parse(idSchool))
            const IIIrdQuarter = await getIIIrdQuarter(year, JSON.parse(idSchool))
            const IVthQuarter = await getIVthQuarter(year, JSON.parse(idSchool))
            //const VthQuarter = await getVthQuarter(year, JSON.parse(idSchool))
            //const VIthQuarter = await getVIthQuarter(year, JSON.parse(idSchool))
            const getQuarterStatus = (quarterData) => {
                return quarterData.data.data
                    .map((res) => {
                        const startDate = new Date(res.startyear, res.startmonth - 1, res.startday);
                        const endDate = new Date(res.endyear, res.endmonth - 1, res.endday);
                        if (dateSelected >= startDate && dateSelected <= endDate) {
                            return res.bimonthly/*.statusSupervisor*/;
                        }
                        return null;
                    })
                    .find((res) => res); // Retorna o primeiro status válido encontrado
            };

            const dataIstQuarter = getQuarterStatus(IstQuarter);
            const dataIIndQuarter = getQuarterStatus(IIndQuarter);
            const dataIIIrdQuarter = getQuarterStatus(IIIrdQuarter);
            const dataIVthQuarter = getQuarterStatus(IVthQuarter);

            // Retorna os dados encontrados em um objeto
            return {
                IstQuarter: dataIstQuarter || null,
                IIndQuarter: dataIIndQuarter || null,
                IIIrdQuarter: dataIIIrdQuarter || null,
                IVthQuarter: dataIVthQuarter || null,
            };
        };


        const run = async () => {
            const result = await fetchQuarters();
            const resClass = await clssInfo(id_class); // ✅ Aqui você espera a Promise

            const turma = resClass.data.data[0];
            console.log("result class:", resClass.data.data);
            console.log("result turma:", turma.dailyStatus);

            if (result.IstQuarter) {
                console.log("dataIstQuarter", result.IstQuarter);
                if (!sameId(id_teacher, physicalEducation)) {
                    setopen(turma.dailyStatus["1º BIMESTRE"].regentTeacher);
                } else {
                    setopen(turma.dailyStatus["1º BIMESTRE"].physicalEducationTeacher);
                }
            }
            if (result.IIndQuarter) {
                console.log("dataIIndQuarter", result.IIndQuarter);
                if (!sameId(id_teacher, physicalEducation)) {
                    setopen(turma.dailyStatus["2º BIMESTRE"].regentTeacher);
                } else {
                    setopen(turma.dailyStatus["2º BIMESTRE"].physicalEducationTeacher);
                }
            }
            if (result.IIIrdQuarter) {
                console.log("dataIIIrdQuarter", result.IIIrdQuarter);
                if (!sameId(id_teacher, physicalEducation)) {
                    setopen(turma.dailyStatus["3º BIMESTRE"].regentTeacher);
                } else {
                    setopen(turma.dailyStatus["3º BIMESTRE"].physicalEducationTeacher);
                }
            }
            if (result.IVthQuarter) {
                console.log("dataIVthQuarter", result.IVthQuarter);
                if (!sameId(id_teacher, physicalEducation)) {
                    setopen(turma.dailyStatus["4º BIMESTRE"].regentTeacher);
                } else {
                    setopen(turma.dailyStatus["4º BIMESTRE"].physicalEducationTeacher);
                }
            }
        };

        run();
    }

    const clickRemovedate = () => {
        setLoading(true)
        sessionStorage.removeItem("selectedDate")
        sessionStorage.removeItem("day")
        sessionStorage.removeItem("month")
        sessionStorage.removeItem("year")

        setSelectedDate('')
        setDay('')
        setMonth('')
        setYear('')
        setLoading(false)
    }

    const Finalyze = async () => {
        setLoading(true)
        const res = await Attendance(attendanceList)
        if (res) {
            console.log("resattendance", res)
            window.location.reload()
        } else {
            console.log("resattendance erro", res)
            window.location.reload()
        }
    }

    const handleCheckAttendance = (id_student, status) => {

        const ctx = resolveTeacherContext();

        if (!ctx) {

            console.error(
                'Não foi possível identificar o professor.',
                {
                    id_teacher,
                    RegentTeacher,
                    RegentTeacher02,
                    physicalEducation
                }
            );

            return;
        }

        setAttendanceList(prevList => {

            const existing =
                prevList.find(
                    att => att.id_student === id_student
                );

            // Toggle
            if (existing?.status === status) {

                return prevList.filter(
                    att => att.id_student !== id_student
                );
            }

            return [

                ...prevList.filter(
                    att => att.id_student !== id_student
                ),

                {
                    id_student,

                    status,

                    day,
                    month,
                    year,

                    id_teacher: ctx.id_teacher,

                    id_teacher02: ctx.id_teacher02,

                    id_class,

                    isPhysicalEducation:
                        ctx.isPhysicalEducation
                }
            ];
        });
    };

    const startEditing = (checkedStdt) => {
        setEditingStudent(checkedStdt._id);
        setEditingStatus(""); // começa vazio
        setNamestudent(checkedStdt);
    };

    const saveEdit = async () => {
        setLoading(true)
        console.log("editingStatus", editingStatus)
        await updateAttendance(editingStudent, editingStatus)
        window.location.reload()
        //setLoading(false)
    };

    const handleDestroy = (checked) => {
        const attendanceIds = checked.map(stdt => stdt._id); // Extrai somente os _id

        setRemoveAttendanceList(attendanceIds); // Armazena apenas os _id no estado
    };

    const Destroy = async () => {
        setLoading(true);
        const res = await DestroyAttendance(RemoveAttendanceList)
        if (res) {
            console.log("res", res)
            window.location.reload()
        }
    };

    const Return = () => {
        navigate(-1)
    };


    const allStudentsMarked = stdt.every(stdt =>
        attendanceList.some(att => att.id_student === stdt._id)
    );

    const normalizeString = (str) => {
        return str
            .normalize("NFD") // Separa caracteres acentuados
            .replace(/[\u0300-\u036f]/g, "") // Remove acentos
            .replace(/[^\w\s]/gi, "") // Remove pontuações
            .toUpperCase(); // Converte para maiúsculas
    };

    console.log("checked", checked)
    //console.log("RemoveAttendanceList", RemoveAttendanceList)
    console.log("attendanceList", attendanceList)
    //console.log("matter", id_matter)
    /*console.log("day", day)
    console.log("month", month)
    console.log("year", year)
    console.log("stdt", stdt)
    console.log("Status", Status)*/

    console.log("open", open)

    if (selectedDate && !isValidSchoolDay) {
        return (
            <Container>
                <ContainerDivs>
                    <h2 style={{ color: "var(--coral, #e5484d)" }}>❌ Dia não letivo</h2>

                    <p>
                        A data selecionada ({String(day).padStart(2, "0")}/
                        {String(month).padStart(2, "0")}/{year}) não é um dia letivo.
                    </p>

                    <Btt02 onClick={clickRemovedate}>
                        Selecionar outra data
                    </Btt02>

                    <ToGoBack onClick={Return}>
                        <SignMessageButtonText>Voltar para a</SignMessageButtonText>
                        <SignMessageButtonTextBold>Turma</SignMessageButtonTextBold>
                    </ToGoBack>
                </ContainerDivs>
            </Container>
        );
    }

    return (
        <Container>
            {loading ?
                <LoadingSpinner />
                :
                <ContainerDivs>
                    {
                        !selectedDate
                        &&
                        <DivInfoDate>
                            <h3>Selecione a Data</h3>

                            <form
                                onSubmit={(e) => {
                                    e.preventDefault(); // evita reload

                                    if (!tempDate || foraDaGradeTemp) return;

                                    const [year, month, day] = tempDate.split("-");

                                    setSelectedDate(tempDate);
                                    setDay(Number(day));
                                    setMonth(Number(month));
                                    setYear(Number(year));
                                }}
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    gap: "15px",
                                    marginTop: "10px"
                                }}
                            >
                                <input
                                    type="date"
                                    value={tempDate}
                                    onChange={(e) => setTempDate(e.target.value)}
                                    style={{
                                        padding: "12px",
                                        borderRadius: "10px",
                                        border: "1px solid var(--line)",
                                        background: "var(--surface)",
                                        color: "var(--text, var(--text-muted))",
                                        colorScheme: "light dark",
                                        fontSize: "16px",
                                        width: "250px"
                                    }}
                                />

                                {foraDaGradeTemp && (
                                    <div role="alert" style={{ background: '#fde8e8', border: '1px solid #dc2626', color: '#991b1b', borderRadius: 10, padding: '8px 12px', fontSize: 13.5, maxWidth: 480 }}>
                                        ⚠️ {foraDaGradeTemp}
                                    </div>
                                )}
                                <AvisoDiasDaGrade grade={gradeDias} style={{ maxWidth: 480 }} />
                                <Btt02 type="submit" disabled={!tempDate || !!foraDaGradeTemp}>
                                    Confirmar Data
                                </Btt02>
                            </form>
                        </DivInfoDate>
                    }
                    {
                        selectedDate && !editingStudent && RemoveAttendanceList.length === 0
                        && (
                            open === 'aberto' ? (
                                <ContainerStudent>
                                    <h2>Frequência</h2>
                                    <DivButton>
                                        <SlActionUndo fontSize={'30px'} onClick={Return} />
                                        <Btt02 onClick={clickRemovedate}>
                                            Selecionar outra data
                                        </Btt02>
                                    </DivButton>
                                    <DataSelected>
                                        {/*<p>Disciplina: {Namematter}</p>*/}<p style={{ color: "var(--teal)" }}>
                                            Data: {String(day).padStart(2, "0")}/{String(month).padStart(2, "0")}/{year}
                                        </p>

                                    </DataSelected>

                                    {loadingList && (
                                        <List>
                                            {[...Array(6)].map((_, i) => (
                                                <SkeletonItem key={i} />
                                            ))}
                                        </List>
                                    )}
                                    {!loadingList && stdt.length > 0 && RemoveAttendanceList.length === 0 &&
                                        <>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    width: '100%',
                                                    justifyContent: "flex-end",
                                                    marginBottom: "20px"
                                                }}
                                            >
                                                <label
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "10px",
                                                        background: "color-mix(in srgb, var(--green) 15%, transparent)",
                                                        border: "2px solid var(--green)",
                                                        borderRadius: "12px",
                                                        padding: "10px 15px",
                                                        fontWeight: "bold",
                                                        fontSize: "15px",
                                                        color: "var(--green)",
                                                        cursor: "pointer",
                                                        boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
                                                        transition: "0.2s"
                                                    }}
                                                >
                                                    Marcar todos como presença

                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) => {
                                                            if (e.target.checked) {
                                                                markAllAsPresent();
                                                            } else {
                                                                setAttendanceList([]);
                                                            }
                                                        }}
                                                        style={{
                                                            transform: "scale(1.5)",
                                                            cursor: "pointer"
                                                        }}
                                                    />
                                                </label>
                                            </div>

                                            <List>

                                                {
                                                    stdt
                                                        .sort((a, b) => normalizeString(a.name).localeCompare(normalizeString(b.name))) // Ordena em ordem alfabética
                                                        .map(stdt => {
                                                            const attendance = attendanceList.find(att => att.id_student === stdt._id);
                                                            const isPresent = attendance?.status === "P";
                                                            const isAbsent = attendance?.status === "F";
                                                            const justifiedAbsence = attendance?.status === "FJ";

                                                            return (
                                                                <Emp key={stdt._id}>
                                                                    <Span>{stdt.name}</Span>
                                                                    <BoxButton>
                                                                        <div className='Presence' >

                                                                            <label style={{ color: isPresent ? "var(--green)" : "var(--text, var(--text-muted))" }}>
                                                                                Presença
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={isPresent}
                                                                                    disabled={excludedStudents.includes(stdt._id)} // Desativa se marcado
                                                                                    onChange={() => handleCheckAttendance(stdt._id, "P")}
                                                                                />
                                                                            </label>
                                                                        </div>
                                                                        <div className='Absence'>
                                                                            <label style={{ color: isAbsent ? "var(--coral, #e5484d)" : "var(--text, var(--text-muted))" }}>
                                                                                Falta
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={isAbsent}
                                                                                    disabled={excludedStudents.includes(stdt._id)} // Desativa se marcado                                                                
                                                                                    onChange={() => handleCheckAttendance(stdt._id, "F")}
                                                                                />
                                                                            </label>
                                                                        </div>
                                                                        <div className='justifi'>
                                                                            {/* Checkbox para marcar alunos sem nota */}
                                                                            <label style={{ color: justifiedAbsence ? "#a06cf0" : "var(--text, var(--text-muted))" }}>
                                                                                Falta Justificada (Atestado)
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={justifiedAbsence}
                                                                                    disabled={excludedStudents.includes(stdt._id)} // Desativa se marcado                                                                
                                                                                    onChange={() => {
                                                                                        handleCheckAttendance(stdt._id, "FJ")

                                                                                    }}
                                                                                />
                                                                            </label>
                                                                        </div>
                                                                        {<div className='not'>
                                                                            <label>Não adicionar</label>
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={excludedStudents.includes(stdt._id)}
                                                                                onChange={() => {
                                                                                    setExcludedStudents((prev) =>
                                                                                        prev.includes(stdt._id)
                                                                                            ? prev.filter((id) => id !== stdt._id) // Remove da lista
                                                                                            : [...prev, stdt._id] // Adiciona à lista
                                                                                    );
                                                                                    handleCheckAttendance(stdt._id, "-")

                                                                                }}
                                                                            />
                                                                        </div>}
                                                                    </BoxButton>
                                                                </Emp>

                                                            );
                                                        })
                                                }
                                                <Btt02 onClick={Finalyze} disabled={!allStudentsMarked}>
                                                    Finalizar Chamada
                                                </Btt02>
                                                {!allStudentsMarked && <p style={{ color: "red" }}>Todos os alunos devem ter um status antes de enviar.</p>}

                                            </List>
                                        </>
                                    }

                                    {checked.length > 0 && RemoveAttendanceList.length === 0 &&
                                        <ListChecked>
                                            {checked
                                                .sort((a, b) => normalizeString(a.id_student.name).localeCompare(normalizeString(b.id_student.name))) // Ordena em ordem alfabética
                                                .map(checkedStdt => (
                                                    <Emp key={checkedStdt._id}>
                                                        <SpanChecked>{checkedStdt.id_student.name}</SpanChecked>

                                                        <BoxButton>
                                                            <div className='check'>
                                                                <Btt02 style={{
                                                                    backgroundColor: checkedStdt.status === 'P' ? 'green' :
                                                                        checkedStdt.status === '-' ? 'black' :
                                                                            checkedStdt.status === 'FJ' ? '#158fa2' :
                                                                                'red'
                                                                }}>
                                                                    {checkedStdt.status}
                                                                </Btt02>

                                                                <Btt02 onClick={() => startEditing(checkedStdt)} style={{ backgroundColor: 'blue' }}>
                                                                    Editar
                                                                </Btt02>
                                                            </div>
                                                        </BoxButton>
                                                    </Emp>
                                                ))}
                                            <Btt02 onClick={() => handleDestroy(checked)}>
                                                Apagar Chamada
                                            </Btt02>
                                        </ListChecked>
                                    }
                                    <ToGoBack onClick={Return}>
                                        <SignMessageButtonText>Voltar para a</SignMessageButtonText>
                                        <SignMessageButtonTextBold>Turma</SignMessageButtonTextBold>
                                    </ToGoBack>
                                </ContainerStudent>
                            ) : (
                                <>
                                    <h3> Bimestre fechado, para editar contate o Diretor ou Supervisor.</h3>

                                    <DivButton>
                                        {/* <Btt02 onClick={clickRemovematter}>
                                    Selecionar outra materia
                                </Btt02>*/}
                                        <Btt02 onClick={clickRemovedate}>
                                            Selecionar outra data
                                        </Btt02>
                                    </DivButton>
                                </>
                            )
                        )}

                    {editingStudent && (
                        <EditContainer>
                            <h3>Editando Frequencia de {namestudent.id_student.name}</h3>
                            {console.log("editingStudent", namestudent.id_student.name)}
                            <select
                                value={editingStatus}
                                disabled={excludedStudents.includes(stdt._id)} // Desativa se marcado
                                onChange={(e) => setEditingStatus(e.target.value)}
                            >
                                <option value="">Selecione</option>
                                <option value="P">Presença</option>
                                <option value="F">Falta</option>
                                <option value="FJ">Falta Justificada (Atestado)</option>
                            </select>
                            {
                                <div className='not'>

                                    <label>Não adicionar</label>
                                    <input
                                        type="checkbox"
                                        checked={excludedStudents.includes(stdt._id)}
                                        onChange={() => {
                                            const isExcluded = excludedStudents.includes(stdt._id);

                                            setExcludedStudents((prev) =>
                                                isExcluded
                                                    ? prev.filter((id) => id !== stdt._id)
                                                    : [...prev, stdt._id]
                                            );

                                            if (isExcluded) {
                                                // voltou a adicionar o aluno
                                                setEditingStatus("P");
                                            } else {
                                                // marcou como não adicionar
                                                setEditingStatus("-");
                                            }
                                        }}
                                    />
                                </div>
                            },
                            {console.log("editing", editingStatus)}

                            <BoxButtonEdit>
                                <Btt02 onClick={saveEdit}>Salvar</Btt02>
                                <Btt02 onClick={() => setEditingStudent(null)}>Cancelar</Btt02>
                            </BoxButtonEdit>

                        </EditContainer>
                    )}
                    {RemoveAttendanceList.length > 0 && (
                        <EditContainer>
                            <h3>Tem certeza que deseja apagar a chamada</h3>
                            <BoxButtonEdit>
                                <Btt02 onClick={Destroy}>Apagar</Btt02>
                                <Btt02 onClick={() => setRemoveAttendanceList([])}>Cancelar</Btt02>
                            </BoxButtonEdit>

                        </EditContainer>
                    )}
                </ContainerDivs>
            }
        </Container>
    )
}

export default IndexAttendance